import { useEffect, useRef, useState } from "react";
import { getConnectionStatus, subscribeConnection } from "../../utils/connectionStatus";
import "./connectionBanner.css";

const RESTORED_VISIBLE_TIME = 3000;
const POSITION = process.env.REACT_APP_CONNECTION_BANNER_POSITION === "top" ? "top" : "bottom";
const BODY_CLASS = "has-connection-banner";
const POSITION_BODY_CLASS = `has-connection-banner-${POSITION}`;

export const ConnectionBanner = () => {
  const [isOnline, setIsOnline] = useState(() => getConnectionStatus() === "online");
  const [showRestored, setShowRestored] = useState(false);
  const wasOffline = useRef(false);

  useEffect(() => subscribeConnection((status) => setIsOnline(status === "online")), []);

  useEffect(() => {
    if (!isOnline) {
      wasOffline.current = true;
      setShowRestored(false);
      return undefined;
    }
    if (!wasOffline.current) return undefined;
    wasOffline.current = false;
    setShowRestored(true);
    const timer = setTimeout(() => setShowRestored(false), RESTORED_VISIBLE_TIME);
    return () => clearTimeout(timer);
  }, [isOnline]);

  useEffect(() => {
    if (POSITION !== "top" || typeof ResizeObserver === "undefined") return undefined;
    const header = document.querySelector(".header-area");
    if (!header) return undefined;
    const apply = () => {
      const height = Math.round(header.getBoundingClientRect().height);
      document.documentElement.style.setProperty("--connection-banner-top", `${height}px`);
    };
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(header);
    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty("--connection-banner-top");
    };
  }, []);

  const visible = !isOnline || showRestored;

  useEffect(() => {
    document.body.classList.toggle(BODY_CLASS, visible);
    document.body.classList.toggle(POSITION_BODY_CLASS, visible);
    return () => {
      document.body.classList.remove(BODY_CLASS);
      document.body.classList.remove(POSITION_BODY_CLASS);
    };
  }, [visible]);

  if (!visible) return null;

  return !isOnline ? (
    <div className={`connection-banner connection-banner-${POSITION} connection-banner-offline`} role="alert">
      <i className="fa-solid fa-wifi connection-banner-icon" />
      <span>No internet connection. Some features may not work.</span>
    </div>
  ) : (
    <div className={`connection-banner connection-banner-${POSITION} connection-banner-online`} role="status">
      <i className="fa-solid fa-wifi" />
      <span>Back online.</span>
    </div>
  );
};
